import * as React from 'react';

const WizardContainer = ({ children }) => {
    return (
    /* The Backdrop/Overlay */
        <div className="tw-fixed tw-inset-0 tw-z-[50] tw-bg-black/40 tw-backdrop-blur-sm tw-flex tw-items-center tw-justify-center tw-p-4">
            {/* The actual constrained box */}
            <div className="tw-relative tw-w-full tw-max-w-[80vw] tw-max-h-[70vh] tw-h-full tw-bg-white tw-shadow-2xl tw-rounded-xl tw-overflow-y-auto tw-overflow-hidden">
                {children}
            </div>
        </div>
    );
};

export { WizardContainer };
